<template>
  <div class="table">
    <div style="text-align: center; margin-bottom: 10px">拆解要求详情</div>
    <table>
      <tr>
        <td>拆解名称</td>
        <td>拆解要求</td>
      </tr>
      <tr v-for="(i, index) in dismantleRequireList" :key="index">
        <td>{{ i.part_name }}</td>
        <td>{{ i.remark }}</td>
      </tr>
      <tr v-if="dismantleRequireList.length <= 0">
        <td colspan="4">暂无数据</td>
      </tr>
    </table>
  </div>
</template>

<script>
import { requestedList } from "@/api/dismantleWork.js";

export default {
  props: ["listItemId"],
  data() {
    return {
      dismantleRequireList: [],
    };
  },
  created() {
    console.log(this.listItemId);
    this.getPartData(this.listItemId);
  },
  methods: {
    // 获取拆解要求
    async getPartData(id) {
      let res = await requestedList({ end_of_lifevehicles_id: 243448 || id });
      this.dismantleRequireList = res.data.data;
      console.log(this.dismantleRequireList);
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  padding: 10px;
  table,
  table tr th,
  table tr td {
    border: 1px solid #000;
  }
  table {
    width: 100%;
    text-align: center;
    border-collapse: collapse;
  }
}
</style>
